/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tumor-staging.reducer';

export const TumorStagingDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const tumorStagingEntity = useAppSelector(state => state.tumorStaging.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="tumorStagingDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.tumorStaging.detail.title">TumorStaging</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.tumorStaging.id">Id</Translate>
            </span>
            <UncontrolledTooltip target="id">
              <Translate contentKey="tinyMedicRestApp.tumorStaging.help.id" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorStagingEntity.id}</dd>
          <dt>
            <span id="stage">
              <Translate contentKey="tinyMedicRestApp.tumorStaging.stage">Stage</Translate>
            </span>
            <UncontrolledTooltip target="stage">
              <Translate contentKey="tinyMedicRestApp.tumorStaging.help.stage" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorStagingEntity.stage}</dd>
          <dt>
            <span id="stagingDate">
              <Translate contentKey="tinyMedicRestApp.tumorStaging.stagingDate">Staging Date</Translate>
            </span>
            <UncontrolledTooltip target="stagingDate">
              <Translate contentKey="tinyMedicRestApp.tumorStaging.help.stagingDate" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorStagingEntity.stagingDate}</dd>
          <dt>
            <span id="displayId">
              <Translate contentKey="tinyMedicRestApp.tumorStaging.displayId">Display Id</Translate>
            </span>
            <UncontrolledTooltip target="displayId">
              <Translate contentKey="tinyMedicRestApp.tumorStaging.help.displayId" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorStagingEntity.displayId}</dd>
          <dt>
            <span id="algorithm">
              <Translate contentKey="tinyMedicRestApp.tumorStaging.algorithm">Algorithm</Translate>
            </span>
            <UncontrolledTooltip target="algorithm">
              <Translate contentKey="tinyMedicRestApp.tumorStaging.help.algorithm" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorStagingEntity.algorithm}</dd>
          <dt>
            <span id="version">
              <Translate contentKey="tinyMedicRestApp.tumorStaging.version">Version</Translate>
            </span>
            <UncontrolledTooltip target="version">
              <Translate contentKey="tinyMedicRestApp.tumorStaging.help.version" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorStagingEntity.version}</dd>
          <dt>
            <span id="title">
              <Translate contentKey="tinyMedicRestApp.tumorStaging.title">Title</Translate>
            </span>
            <UncontrolledTooltip target="title">
              <Translate contentKey="tinyMedicRestApp.tumorStaging.help.title" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorStagingEntity.title}</dd>
          <dt>
            <span id="subtitle">
              <Translate contentKey="tinyMedicRestApp.tumorStaging.subtitle">Subtitle</Translate>
            </span>
            <UncontrolledTooltip target="subtitle">
              <Translate contentKey="tinyMedicRestApp.tumorStaging.help.subtitle" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorStagingEntity.subtitle}</dd>
          <dt>
            <span id="notes">
              <Translate contentKey="tinyMedicRestApp.tumorStaging.notes">Notes</Translate>
            </span>
            <UncontrolledTooltip target="notes">
              <Translate contentKey="tinyMedicRestApp.tumorStaging.help.notes" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorStagingEntity.notes}</dd>
          <dt>
            <span id="stagingInput">
              <Translate contentKey="tinyMedicRestApp.tumorStaging.stagingInput">Staging Input</Translate>
            </span>
            <UncontrolledTooltip target="stagingInput">
              <Translate contentKey="tinyMedicRestApp.tumorStaging.help.stagingInput" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorStagingEntity.stagingInput}</dd>
          <dt>
            <span id="stagingOutcome">
              <Translate contentKey="tinyMedicRestApp.tumorStaging.stagingOutcome">Staging Outcome</Translate>
            </span>
            <UncontrolledTooltip target="stagingOutcome">
              <Translate contentKey="tinyMedicRestApp.tumorStaging.help.stagingOutcome" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorStagingEntity.stagingOutcome}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.tumorStaging.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.tumorStaging.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorStagingEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.tumorStaging.cursor">Cursor</Translate>
            </span>
            <UncontrolledTooltip target="cursor">
              <Translate contentKey="tinyMedicRestApp.tumorStaging.help.cursor" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorStagingEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tumorStaging.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tumorStaging.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorStagingEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.tumorStaging.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.tumorStaging.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorStagingEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tumorStaging.timestampEntry">Timestamp Entry</Translate>
            </span>
            <UncontrolledTooltip target="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tumorStaging.help.timestampEntry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorStagingEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tumorStaging.recordedBy">Recorded By</Translate>
          </dt>
          <dd>{tumorStagingEntity.recordedBy ? tumorStagingEntity.recordedBy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tumorStaging.tumor">Tumor</Translate>
          </dt>
          <dd>{tumorStagingEntity.tumor ? tumorStagingEntity.tumor.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/tumor-staging" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/tumor-staging/${tumorStagingEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TumorStagingDetail;
